import { BasePresenter } from "../base/base.presenter";
import { IMainLayout } from "../../interfaces/containers/main-layout.interface";
import { ILang } from "../../models";
import { useSelector } from "react-redux";
import { moment } from "../../utils/utilities";
import { locale, loadMessages } from "devextreme/localization";
import * as numeral from "numeral";

const esMessages = require("devextreme/localization/messages/es.json");
const enMessages = require("devextreme/localization/messages/en.json");
const ptMessages = require("devextreme/localization/messages/pt.json");
const frMessages = require("devextreme/localization/messages/fr.json");

require("moment/locale/es");
require("moment/locale/fr");
require("moment/locale/pt");
require("numeral/locales/es.js");
require("numeral/locales/pt-pt.js");
require("numeral/locales/fr.js");

export class MainLayoutPresenter extends BasePresenter<IMainLayout> {
  public initializeLanguage() {
    const dxLanguages: any = {
      es: esMessages,
      en: enMessages,
      pt: ptMessages,
      fr: frMessages,
    };
    const lang = useSelector(this.context.sessionStore.selectLang) as ILang;
    if (lang !== null) {
      moment.locale(lang.label.toLowerCase());
      const dxlanguage = dxLanguages[lang.label.toLowerCase()];
      loadMessages(dxlanguage);
      locale(lang.label.toLowerCase());
      numeral.locale(lang.label.toLowerCase());
    }
  }

  public dispatchMainStates() {
    this.dispatcher(this.context.sessionStore.getLangs());
    this.dispatcher(this.context.sessionStore.getLabels());
    this.dispatcher(this.context.sessionStore.getParams());
  }

  public get isLoadingContainer() {
    const isLoadingContainer = useSelector(
      this.context.sessionStore.selectLoadingContainer
    );
    return isLoadingContainer;
  }
  public get progress() {
    const progress = useSelector(this.context.sessionStore.selectProgress);
    return progress;
  }
  public get pendingLoad() {
    const pendingLoad = useSelector(
      this.context.sessionStore.selectPendingLoad
    );
    return pendingLoad;
  }
}
